export enum ParamObjectType {
  Process,
  Node,
  Service,
  User,
  Premise,
}
